import MusicMockImage from "@/assets/home-gallery-1.png";
import { useInViewOnce } from "@/hooks/useInViewOnce";
export default function AscenderMusicSpotlight() {
  const {
    ref,
    inView
  } = useInViewOnce<HTMLElement>();
  return <section ref={ref} className={["mt-12", "grid gap-8 md:grid-cols-[minmax(0,2fr)_minmax(0,3fr)] md:items-center", inView ? "animate-fade-in" : "opacity-0"].join(" ")}>
      <div className="space-y-3">
        <p className="section-title">Curso de música</p>
        <h2 className="text-2xl font-semibold text-foreground">Uma aula pode mudar o rumo de uma história.</h2>
        <p className="max-w-xl text-sm text-muted-foreground">
          Aqui, a música vira linguagem de cuidado: disciplina, pertencimento e coragem para tentar de novo. Não é só
          aprender acordes — é descobrir que existe futuro.
        </p>
        
      </div>

      <figure className="card-ambient p-4">
        <div className="overflow-hidden rounded-2xl bg-muted shadow-[0_12px_50px_-20px_hsl(var(--foreground)/0.55)]">
          <img alt="Imagem ilustrativa do curso de música (mock)" loading="lazy" className="h-80 w-full object-cover" width={600} height={320} src="/lovable-uploads/d778e9e5-b555-44fd-97a9-485068fc5fdf.jpg" />
        </div>
        
      </figure>
    </section>;
}